import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { forkJoin } from "rxjs";
import { SharedComponents } from "../../../../../components/shared.module";
import { TcoTableComponent } from "../../../../../components/tco-table/tco-table.component";
import { ConfigService } from "../../../../../core/services/config/config.service";
import { RestTcoService } from "../../../../../core/services/rest-tco.service";
import { TcoProjectService } from "../../../../../core/services/tco-project/tco-project.service";
import { UtilitiesService } from "../../../../../core/services/utilities.service";
import { MaterialModule } from "../../../../../core/shared/material.module";
import { tcoDuplicatedClusterTable } from "../../../../../core/table-templates/tco-duplicated-cluster-table";

@Component({
  selector: "app-duplicate-test-cases",
  standalone: true,
  imports: [SharedComponents, CommonModule, MaterialModule, TcoTableComponent],
  templateUrl: "./duplicate-test-cases.component.html",
  styleUrl: "./duplicate-test-cases.component.scss",
})
export class DuplicateTestCasesComponent implements OnInit {
  extractedRealm: string | null;
  chart: any;
  testArray: any[] = [];
  segmentData: any;
  allduplicateTestcases: any[] = [];
  uniquesFromAllOverlappingTestcases: any;
  metric: any = {};
  chartData: Record<string, number> = {};
  selectedClusterId: any;
  clusterItems: any = [];
  selectedTestCases: any[] = [];
  filteredTestArray: any[] = [];
  testIdsInCluster: number[] = [];
  testIdsForSelectedCluster: any;
  selectedClusterTopKeywords: string | null = null;
  retainedUniqueTestIdsInCluster: any = [];
  uniqueTestIdsInEachCluster: number[] = [];
  selectedTestId: string | null = null;
  clusterTableColumns = tcoDuplicatedClusterTable;
  isHeaderChecked = false;
  selectedTestIdValues: number[] = [];
  colors: any = [
    {
      bg: "rgba(47, 118, 255, 0.05)",
      border: "rgba(47, 118, 255, 1)",
    },
    {
      bg: "rgba(168, 37, 219, 0.05)",
      border: "rgba(168, 37, 219, 1)",
    },
  ];
  resetTableSelection = false;

  @Input() modelId: any;
  @Output() moveToPreviousTabEvent = new EventEmitter<void>();
  @Input() uniqueFromDuplicateIds: string[] = [];
  isLoading: boolean = false;

  constructor(
    private restTcoService: RestTcoService,
    private tcoProjectService: TcoProjectService,
    private configService: ConfigService,
    private utilityService: UtilitiesService
  ) {
    this.tcoProjectService.getModalId().subscribe((id) => {
      this.modelId = id;
    });
    this.extractedRealm = this.configService.getConfig("isDomainResolver")
      ? this.utilityService?.extractRealmFromUrl()
      : sessionStorage.getItem("selectedRealm");
  }

  ngOnInit(): void {
    this.getdata();
  }

  getdata() {
    if (this.modelId) {
      this.isLoading = true;

      const segmentation$ =
        this.restTcoService.getAllDuplicatesSegmentationDataByModelId(
          this.modelId
        );
      const testcases$ = this.restTcoService.getAllDuplicatesTestcasesByModelId(
        this.modelId
      );
      const uniqueCount$ =
        this.restTcoService.getDuplicatesCountUniqueInDuplicatesByModelId(
          this.modelId
        );

      forkJoin([segmentation$, testcases$, uniqueCount$]).subscribe(
        ([segmentationData, testcasesData, uniqueCount]) => {
          // Segmentation response
          this.segmentData = segmentationData;
          this.getAllDuplicateTestCases();

          // Test cases response
          this.testArray = testcasesData;
          if (testcasesData.length > 11) {
            testcasesData = testcasesData.slice(0, 11);
          }

          this.chartData = {};
          testcasesData.forEach((item: any) => {
            const keyword = item.topKeywords;
            const count = JSON.parse(item.testId).length;
            this.chartData[keyword] = count;
          });

          this.metric.data = this.chartData;
          this.metric.meta = [
            {
              x: "Clusters",
              y: "Test Case Duplication Count",
            },
          ];

          // Unique count response
          this.uniquesFromAllOverlappingTestcases = uniqueCount;
          this.selectedClusterId = this.testArray[0]?.clusterId;
          this.onClusterIdChange();

          this.isLoading = false;
        }
      );
    }
  }

  getAllDuplicateTestCases() {
    this.allduplicateTestcases = [];
    const testIds = this.testArray
      .map((item) =>
        item.testId
          .replace(/\[|\]/g, "")
          .split(",")
          .map((id: string) => id.trim())
      )
      .flat();
    const filteredSegments = this.segmentData.filter((segment: any) =>
      testIds.includes(segment.testId.trim())
    );
    this.allduplicateTestcases = filteredSegments;
  }

  compare() {
    console.log(this.filteredTestArray);
    this.selectedTestCases = this.filteredTestArray.filter(item => item.checked);
    this.isHeaderChecked = this.filteredTestArray.every(item => item.checked);
    this.selectedTestIdValues= this.filteredTestArray.filter(item => item.checked).map(item => item.testId);
  }

  onClusterIdChange() {
    this.selectedTestCases = [];
  
    // Reset the selection flag before updating filteredTestArray
    this.resetTableSelection = true;
  
    //Reset checkbox status
    this.filteredTestArray.forEach((item) => {
      item.checked = false;
    });
  
    //Selected cluster Testcases
    if (this.selectedClusterId) {
      this.testIdsForSelectedCluster = this.testArray
        .filter((testCase) => testCase.clusterId === this.selectedClusterId)
        .map((testCase) => JSON.parse(testCase.testId));
  
      const foundSelectedCluster = this.testArray.find(
        (item) => item.clusterId === this.selectedClusterId
      );
      if (foundSelectedCluster) {
        this.selectedClusterTopKeywords = foundSelectedCluster.topKeywords;
        console.log(
          "selectedClusterKeywords :",
          this.selectedClusterTopKeywords
        );
      }
    } else {
      this.testIdsForSelectedCluster = [];
    }
    this.testIdsInCluster = this.testIdsForSelectedCluster[0];
    this.getRetainedUniquesInDuplicates();
  
    const matchingTestIds = this.uniquesFromAllOverlappingTestcases.filter(
      (testcase: any) => {
        return this.testIdsInCluster.includes(Number(testcase.testId));
      }
    );
  
    this.uniqueTestIdsInEachCluster = matchingTestIds.map((testcase: any) =>
      Number(testcase.testId)
    );
    this.selectedTestId = null;
    this.filteredTestArray = [];
    this.filterTestArray();
    setTimeout(() => {
      this.resetTableSelection = false;
    }, 0);
  }

  getRetainedUniquesInDuplicates() {
    const testIdsInClusterAsStrings = this.testIdsInCluster.map((id) =>
      id.toString()
    );
    if (this.modelId) {
      this.restTcoService
        .getNewUniquesInDuplicates(
          this.modelId,
          "Duplicate",
          testIdsInClusterAsStrings
        )
        .subscribe((res: any) => {
          const retainedUniquesResponse = res;
          this.retainedUniqueTestIdsInCluster = retainedUniquesResponse.map(
            (item: any) => item.testId
          );
        });
    }
  }

  filterTestArray() {
    this.filteredTestArray = [];
    this.segmentData.forEach((segment: any) => {
      const parsedTestId = parseInt(segment.testId);
      if (
        this.testIdsForSelectedCluster.length > 0 &&
        this.testIdsForSelectedCluster[0].includes(parsedTestId)
      ) {
        this.filteredTestArray.push(segment);
      }

      const formattedSteps = this.formatSteps(segment.corStepDesc);
      segment.formattedCorStepDesc = formattedSteps;
    });
    const testIdsUniquesInClusterAsStrings =
      this.uniqueTestIdsInEachCluster.map((id) => id.toString());
    this.filteredTestArray.forEach((item) => {
      item.retain = testIdsUniquesInClusterAsStrings.includes(item.testId);
    });
    console.log("Filtered Segment Array:", this.filteredTestArray);
  }

  formatSteps(description: string): string[] {
    if (!description.startsWith("Step")) {
      return [description];
    }

    const steps = description.split("Step");
    steps.shift(); // Remove the empty first element

    const formattedSteps = steps.map((step) => {
      const lines = step.split(/\n/);
      const formattedSubSteps = lines.map((line, index) => {
        if (index === 0) {
          return `Step ${line.trim()}`;
        } else {
          return `\t${line.trim()}`;
        }
      });
      return formattedSubSteps.join("\n");
    });

    return formattedSteps;
  }

  handleRowSelection(event: any) {}

  highlightTestDesc(testCase: any, wordIndex: number): boolean {
    if (!this.selectedTestCases || this.selectedTestCases.length === 0) {
      return false;
    }
    for (const selectedTest of this.selectedTestCases) {
      const testNameWords = selectedTest.description.split(" ");
      if (
        testNameWords[wordIndex] !== testCase.description.split(" ")[wordIndex]
      ) {
        return true;
      }
    }
    return false;
  }

  getHighlightColor(cardIndex: number): string {
    return "#D7E1FF";
  }

  highlightFormattedStepDesc(
    testCase: any,
    wordIndex: number,
    lineIndex: number
  ): boolean {
    if (!this.selectedTestCases || this.selectedTestCases.length === 0) {
      return false;
    }

    if (
      !testCase.formattedCorStepDesc ||
      lineIndex >= testCase.formattedCorStepDesc.length
    ) {
      // If formattedCorStepDesc is undefined or lineIndex is out of bounds, return false
      return false;
    }

    for (const selectedTest of this.selectedTestCases) {
      if (
        !selectedTest.formattedCorStepDesc ||
        lineIndex >= selectedTest.formattedCorStepDesc.length
      ) {
        // If formattedCorStepDesc in selectedTest is undefined or lineIndex is out of bounds, skip to the next iteration
        continue;
      }
      const compareToSentence = selectedTest.formattedCorStepDesc[lineIndex];
      if (!compareToSentence) return true;

      const testNameWords =
        selectedTest.formattedCorStepDesc[lineIndex].split(" ");

      if (
        !testCase.formattedCorStepDesc[lineIndex] ||
        testNameWords[wordIndex] !==
          testCase.formattedCorStepDesc[lineIndex].split(" ")[wordIndex]
      ) {
        return true;
      }
    }

    return false;
  }

  highlightExpectResult(testCase: any, wordIndex: number): boolean {
    if (!this.selectedTestCases || this.selectedTestCases.length === 0) {
      return false;
    }
    for (const selectedTest of this.selectedTestCases) {
      const testNameWords = selectedTest.cleanedExpResult.split(" ");
      if (
        testNameWords[wordIndex] !==
        testCase.cleanedExpResult.split(" ")[wordIndex]
      ) {
        return true;
      }
    }
    return false;
  }

  getColor(ind: number) {
    let targetInd = ind % 2;
    return this.colors[targetInd];
  }
  goBack() {
    this.moveToPreviousTabEvent.emit();
  }
}
